/* tslint:disable:max-line-length */
import * as React from 'react';
import { ReactNode } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push as pushUnbound } from 'redux-router';
import 'whatwg-fetch';
import {
  apiStatuses,
  checkDuplicateAndQuarantine as checkDuplicateAndQuarantineUnbound,
  FetchProductInfo,
  fetchProductInfo as fetchProductInfoUnbound,
  userLoggedInDeferred
} from '../actions/Actions';
import {
  IDuplicateAndQuarantine,
  IProductInfo,
  IReduxRouterAction,
  IReferer,
  IUserInfo,
  IUserLoggedIn
} from '../CustomTypes';

export interface IProductWrapperParamProps {
  children: ReactNode;
  pathname: string;
  productInfo: IProductInfo;
  productId?: string;
  redirectUri: string;
  referer: IReferer;
  refererUri: string;
  sig: string;
  userInfo: IUserInfo;
}
export interface IProductWrapperActionProps {
  checkDuplicateAndQuarantine: checkDuplicateAndQuarantineUnbound;
  fetchProductInfo: FetchProductInfo;
  push: IReduxRouterAction;
}
export interface IProductWrapperProps
  extends IProductWrapperParamProps,
    IProductWrapperActionProps {}

export class ProductWrapper extends React.Component<IProductWrapperProps, {}> {
  private static loadData(props: IProductWrapperProps) {
    const {
      checkDuplicateAndQuarantine,
      fetchProductInfo,
      pathname,
      productId,
      push,
      redirectUri
    } = props;
    (fetchProductInfo(productId) as any).then((product: IProductInfo) => {
      document.title = `Kjøp ${product.header}`;

      userLoggedInDeferred.promise.then((user: IUserLoggedIn) => {
        (checkDuplicateAndQuarantine(
          product.productId,
          product.owningClient,
          user.spidId,
          user.sig
        ) as any)
          .then((result: IDuplicateAndQuarantine) => {
            if (
              /\/receipt|\/placeorder|\/productquarantined|\/components/.test(
                pathname
              ) === false
            ) {
              if (result.isDuplicate === true) {
                push(
                  `/products/${productId}/receipt?duplicate=true&spidId=${
                    user.spidId
                  }&sig=${encodeURIComponent(
                    user.sig || ''
                  )}&redirectUri=${encodeURIComponent(redirectUri || '')}`
                );
              } else if (result.isQuarantine === true) {
                push(
                  `/products/${productId}/productquarantined?spidId=${
                    user.spidId
                  }&sig=${encodeURIComponent(user.sig || '')}&referer=${props
                    .referer.referer ||
                    props.refererUri ||
                    ''}`
                );
              }
            }
          })
          .catch(() => 'ignore');
      });
    });
  }

  public render() {
    if (this.props.productInfo.apiStatus === apiStatuses.SUCCESS) {
      return <div>{this.props.children}</div>;
    }
    return null;
  }

  public componentWillMount() {
    ProductWrapper.loadData(this.props);
  }

  public componentWillReceiveProps(nextProps: IProductWrapperProps) {
    if (nextProps.productId !== this.props.productId) {
      ProductWrapper.loadData(nextProps);
    }
  }
}

export default connect(
  state =>
    ({
      pathname: state.router.location.pathname,
      productId: state.router.params.productId,
      productInfo: state.productInfo,
      redirectUri: state.router.location.query.redirect_uri,
      referer: state.referer,
      refererUri: state.router.location.query.referer,
      sig: state.router.location.query.redirect_uri,
      userInfo: state.userInfo
    } as IProductWrapperParamProps),
  dispatch =>
    bindActionCreators(
      {
        checkDuplicateAndQuarantine: checkDuplicateAndQuarantineUnbound,
        fetchProductInfo: fetchProductInfoUnbound,
        push: pushUnbound
      },
      dispatch
    ) as IProductWrapperActionProps
)(ProductWrapper);



// WEBPACK FOOTER //
// ./src/layout-components/ProductWrapper.tsx